/* MM Featured Collection — auto scroll carousel */
(function () {
  if (window.__mmFeaturedCollectionInit) return;
  window.__mmFeaturedCollectionInit = true;

  const SCROLL_SPEED = 0.6; // px per frame ≈ 36px/s @60fps
  const RESUME_DELAY = 1800; // ms after manual interaction

  function init(root) {
    const viewport = root.querySelector('.mm-featured-collection__viewport');
    const track = root.querySelector('.mm-featured-collection__track');
    const navButtons = Array.from(root.querySelectorAll('[data-mm-featured-nav]'));
    if (!viewport || !track) return;

    const cards = Array.from(track.querySelectorAll('.mm-featured-collection__card'));
    if (cards.length === 0) return;

    /*
     * Les fleches se centrent sur le VISUEL, pas sur la carte entiere.
     *
     * Retour Alexia (PDF V2, remarque 31) : « la fleche pour faire defiler les
     * parfums est mal positionnee ». Mesure sur iPhone 390 px : carte a y=963
     * haute de 516, image a y=975 haute de 365 ; un `top: 50%` de la carte
     * posait donc la fleche a 1211 alors que le centre du visuel est a 1158,
     * soit 53 px trop bas -- la fleche tombait dans le bloc titre + prix.
     *
     * Le ratio n'est pas fige en dur : il ne peut pas l'etre, il depend de la
     * hauteur du bloc de texte, qui varie avec la longueur du nom du parfum et
     * la presence des formats. Il est donc MESURE et republie a chaque
     * changement de mise en page.
     */
    const centrerFleches = () => {
      const visuel = cards[0].querySelector('.mm-featured-collection__card-image-wrap');
      if (!visuel) return;
      const carte = cards[0].getBoundingClientRect();
      const image = visuel.getBoundingClientRect();
      if (!carte.height) return;
      const ratio = (image.top - carte.top + image.height / 2) / carte.height;
      root.style.setProperty('--mm-fc-nav-top', (ratio * 100).toFixed(2) + '%');
    };

    /* Pas de mesure immédiate au chargement : getBoundingClientRect() forçait le calcul de
       mise en page de toute la page pendant son chargement (« forced reflow », PageSpeed du
       27/09/2026). Le ResizeObserver rappelle centrerFleches dès la première mise en page. */
    window.addEventListener('resize', centrerFleches, { passive: true });
    window.addEventListener('load', centrerFleches);
    if ('ResizeObserver' in window) new ResizeObserver(centrerFleches).observe(cards[0]);
    else centrerFleches();

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayEnabled = root.dataset.autoplay !== 'false' && !reduceMotion;

    let isPaused = false;
    let resumeTimer = null;
    let rafId = null;

    function getMaxScroll() {
      return viewport.scrollWidth - viewport.clientWidth;
    }

    function step() {
      if (!isPaused) {
        const max = getMaxScroll();
        if (max <= 0) {
          rafId = requestAnimationFrame(step);
          return;
        }
        let next = viewport.scrollLeft + SCROLL_SPEED;
        if (next >= max) next = 0;
        viewport.scrollLeft = next;
      }
      rafId = requestAnimationFrame(step);
    }

    function pauseTemporarily(delay) {
      isPaused = true;
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        isPaused = false;
      }, delay || RESUME_DELAY);
    }

    // Hover pause
    root.addEventListener('mouseenter', () => { isPaused = true; }, true);
    root.addEventListener('mouseleave', () => {
      if (!resumeTimer) isPaused = false;
    }, true);

    // Touch / wheel / scroll pause
    viewport.addEventListener('touchstart', () => pauseTemporarily(2500), { passive: true });
    viewport.addEventListener('wheel', () => pauseTemporarily(1500), { passive: true });

    function getCardWidth() {
      if (cards.length < 2) return cards[0].offsetWidth;
      return cards[1].offsetLeft - cards[0].offsetLeft;
    }

    navButtons.forEach((button) => {
      const direction = button.dataset.mmFeaturedNav === 'prev' ? -1 : 1;
      button.addEventListener('click', () => {
        viewport.scrollTo({ left: viewport.scrollLeft + direction * getCardWidth(), behavior: 'smooth' });
        pauseTemporarily(2200);
      });
    });

    /* Le défilement automatique ne démarre que quand le carrousel est à l'écran (observateur
       ci-dessous) : il tournait dès le chargement, sous le hero, pendant que la page se construisait. */
    if (autoplayEnabled && !('IntersectionObserver' in window)) {
      rafId = requestAnimationFrame(step);
    }

    // Pause when off-screen
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting && rafId) {
            cancelAnimationFrame(rafId);
            rafId = null;
          } else if (e.isIntersecting && !rafId && autoplayEnabled) {
            rafId = requestAnimationFrame(step);
          }
        });
      }, { threshold: 0 });
      io.observe(root);
    }

    // AJAX Form submissions for quick add -> updates and opens the cart drawer
    root.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const submitBtn = form.querySelector('button[type="submit"]');
        const idInput = form.querySelector('input[name="id"]');
        if (!idInput || !idInput.value) return;

        let originalText = '';
        const ctaLabel = submitBtn ? submitBtn.querySelector('.mm-featured-collection__card-cta-label') : null;
        if (submitBtn) {
          submitBtn.disabled = true;
          if (ctaLabel) {
            originalText = ctaLabel.textContent;
            ctaLabel.textContent = /^fr/i.test(document.documentElement.lang || '') ? 'AJOUT…' : 'ADDING…';
          } else {
            submitBtn.style.opacity = '0.5';
          }
        }

        try {
          const body = new FormData(form);
          body.append('sections', 'cart-drawer,cart-icon-bubble');
          const res = await fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
            method: 'POST',
            body,
          });
          if (!res.ok) throw new Error('Add failed');

          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.refresh === 'function') {
            await drawer.refresh({ open: true });
          } else {
            window.location.reload();
          }
        } catch (err) {
          console.error('Failed to quick add to cart:', err);
        } finally {
          if (submitBtn) {
            submitBtn.disabled = false;
            if (ctaLabel) {
              ctaLabel.textContent = originalText;
            } else {
              submitBtn.style.opacity = '';
            }
          }
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('.mm-featured-collection').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('.mm-featured-collection');
    if (root) init(root);
  });
})();
